import { createContext } from "react";

const WindowSizeContext = createContext(null);

export default WindowSizeContext;